import { render, staticRenderFns } from "./epasNewMenu.vue?vue&type=template&id=ce786a76&scoped=true&"
import script from "./epasNewMenu.vue?vue&type=script&lang=js&"
export * from "./epasNewMenu.vue?vue&type=script&lang=js&"
import style0 from "./epasNewMenu.vue?vue&type=style&index=0&id=ce786a76&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce786a76",
  null
  
)

export default component.exports